import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy,
  ViewChild,
  TemplateRef,
  ElementRef,
} from '@angular/core';
import { differenceInCalendarDays } from 'date-fns';
import _ from 'lodash';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';

import { OrderMoveHouseComponent } from '@root/component/order-move-house/order-move-house.component';
import { ContinueStayComponent } from './continue-stay/continue-stay.component';
import { MultiHouseCalendarService } from '@root/router/house/component/multi-house-calendar/multi-house-calendar.service';
import { HouseStatusService } from '@root/router/house/house-status/house-status.service';
import { HouseOrderboxComponent } from '@root/router/house/house-orderbox/house-orderbox.component';
import { ModalService } from '@root/router/index/modal.service';
import { DateService } from '@root/shared/service/date.service';
import {OVERSEAS_EDITION_TIME_FORMAT, MAX_AMOUNT, PLATFORM_TYPE} from '@root/config';
import { NoteV2Component } from '@root/router/component/note-v2/note-v2.component';
import { OrderV2Service } from '@root/router/order-v2/order-v2.service';
import { TranslateService } from '@root/shared/service/translate.service';
import { Translate, WritePermissionGurd } from '@root/util/decorator';
import getSymbolFromCurrency from 'currency-symbol-map';
import { ViewVoucherComponent } from '@root/component/view-voucher/view-voucher.component';
import { StoreService } from '@root/shared/service/store.service';
import { HouseOrderDetailComponent } from '../house-order-detail.component';
import {
  SwitchPageService,
  PAGES_NAME,
  PageName,
} from '@root/router/component/order-detail-sidebar/switch-page.service';
import {SystemService} from "@root/router/system/system.service";
import {HttpClient} from "@angular/common/http";
import {ACLService} from "@delon/acl";
import {AppService} from "@root/app.service";

interface Image {
  filename?: string;
  original_url?: string;
  small_url?: string;
  large_url?: string;
}

@Component({
  selector: 'host-house-order-basic',
  templateUrl: './house-order-basic.component.html',
  styleUrls: ['./house-order-basic.component.scss'],
})
export class HouseOrderBasicComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  get orderDetail () { return this._orderDetail; }
  set orderDetail (value) {
    this._orderDetail = value;

    if (value) {
      this.currentCreatorId = value.creator_operator_id;
    }
  }

  get total_nights() {
    const date = this.form.get('date').value;
    const total_nights = moment(date[1]).diff(date[0], 'days');
    return total_nights || 0;
  }

  // get column() {
  //   return this.from === "calendar" ? 2 : 1;
  // }

  get editExtensionHouseFeeErrorText() {
    const errorText = this.translateService.syncGet(
      'errorText.order.house_fee'
    );
    return `${errorText}
    ${_.get(this.orderDetail, 'currency_type')}
    ${_.get(this.orderDetail, 'amount_items.online_house_fee.amount')}`;
  }

  get houseFeeEmptyErrorText() {
    return this.translateService.syncGet('errorText.order.house_fee');
  }

  get use12Hours() {
    const timeFormat = this.dateService.getTimeFormat();
    return timeFormat === OVERSEAS_EDITION_TIME_FORMAT.HOUR_TWELVE;
  }

  get timeFormat() {
    return this.dateService.getAngularFormat([null, 'hm']);
  }

  get angularDateFormat() {
    return this.dateService.getAngularFormat(['YMD']);
  }

  get isSubaccount () {
    return this.acl.can({ role: ['slave'] });
  }
  get isConflict() {
    return !!(this.orderDetail && this.orderDetail.conflict_label.is_conflict);
  }

  get isInternational() {
    return this.app.app.international;
  }
  //#endregion
  constructor(
    private fb: FormBuilder,
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private router: Router,
    private orderService: OrderV2Service,
    private calendarService: MultiHouseCalendarService,
    private houseStatusService: HouseStatusService,
    private globalModalService: ModalService,
    private dateService: DateService,
    private translateService: TranslateService,
    private el: ElementRef,
    private storeService: StoreService,
    private switchPageService: SwitchPageService,
    private systemSrv: SystemService,
    private http: HttpClient,
    private acl: ACLService,
    private app: AppService
  ) {}
  readonly Platform: typeof PLATFORM_TYPE = PLATFORM_TYPE;
  _orderDetail;
  @Input() pageType: 'sidebar' | 'modal' = 'sidebar';
  @Input() loading = false;
  @Output() refreshModal = new EventEmitter();
  @Output() changeOrder = new EventEmitter();
  @ViewChild('tagTemplate') tagTemplate: TemplateRef<any>;
  @ViewChild('tagModal') tagModal;

  form: FormGroup = this.fb.group({
    date: [''],
    house_price: [0, Validators.required],
    commission: 0,
    reservation_note: '',
    name: '',
    mobile: '',
    personCount: '',
    channel: '',
    inTime: null,
    outTime: null,
    currency: null,
    password: null,
    visible_password_time: null,
    need_credential: null,
  });
  showOrderAmount = true; // true代表展示订单金额。false代表编辑订单金额
  showOrderRemarks = true; // true代表展示订单备注。false代表编辑订单备注
  showOrderInfo = true; // true代表展示订单信息。false代表编辑手工订单来源渠道
  checkInOPen = false; // true代表到店时间选择框打开。false代表到店时间选择框关闭
  checkOutOPen = false; // true代表退房时间选择框打开。false代表退房时间选择框关闭
  showHousesInfo = false;

  today = new Date();
  toChat = false;
  refresh = false;
  showTotalNights;
  acceptLoading = false;
  refuseLoading = false;
  hasHouseStatus = ['completed', 'wait_stay', 'staying'];
  cancelHouseStatus = ['cancelled', 'denied', 'timeout'];
  // conflictDate = [];
  channelOptions = [];
  leavedChannelOptions = [];

  maxAmount = MAX_AMOUNT;
  checkingExtensionHouseFee = false;

  currentTags = []; // 已经确认选择的tag
  listOfTag = []; // 所有共筛选的tag
  totalChecked = 0;
  tagModel;
  boxCount = 0;
  currencyList = [];
  reservationList = [];
  currencySymbol;

  oldInTime;
  oldOutTime;
  fillInPasswordManually = false;
  passwordVisibleTimeList = this.orderService.getLockPasswordVisibleTimeList();
  checkinInfoLink;
  showGuideInfo = true;
  patchingValue = false;
  // depositEditting = false;
  maxSize = 10; // 最多上传10张照片
  listOfImage: Array<Image> = [];

  automation = 0;

  hourCalendarCollapsed =
    this.storeService.get('collapse_hour_calendar_in_order_detail', 2) === null
      ? true
      : this.storeService.get('collapse_hour_calendar_in_order_detail', 2);

  @Translate('component.upload.image_format_restrictions') extLimitWarning;
  @Translate('component.upload.image_number_reached_limit') amountLimitWarning;
  @Translate('warning.upload_image_too_large') sizeLimitWarning;

  //#region creator
  listOfSubaccount = [];
  currentCreatorId;

  disabledDate = (current: Date): boolean => {
    // let conflict = false;
    const diff = differenceInCalendarDays(current, this.today);
    // _.forEach(this.conflictDate, (item) => {
    //   if (differenceInCalendarDays(current, item) === 0) {
    //     conflict = true;
    //   }
    // });
    return diff > 90 || diff < -90;
  };

  beforeUpload = (file) => {
    const size = file.size;
    const type = file.type;

    if (['image/jpeg', 'image/jpg', 'image/png'].indexOf(type) === -1) {
      // this.messageService.info('只允许上传jpg和png格式的图片');
      this.messageService.info(this.extLimitWarning);
      return false;
    }

    if (this.listOfImage.length >= this.maxSize) {
      // this.messageService.info('上传图片数量已达上限');
      this.messageService.info(this.amountLimitWarning);
      return false;
    }

    if (size > 10 * 1024 * 1024) {
      // this.messageService.info('图片过大，请选择小于10M的图片上传！');
      this.messageService.info(this.sizeLimitWarning);
      return false;
    }

    return true;
  };

  ngOnInit() {
    this.refreshForTag();
    this.getOptions();
    this.getCurrencyList();
    this.fetchSubaccountList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderDetail'] && changes['orderDetail'].currentValue) {
      this.getReservations();
      // this.formatTags();
      this.orderDetail = this.format(changes['orderDetail'].currentValue);
      // this.orderDetail.thirdparty_type = 11
      this.initCheckTime();
      this.initStatus();
      this.showTotalNights = moment(this.orderDetail.check_out).diff(
        this.orderDetail.check_in,
        'days'
      );
      this.currencySymbol = getSymbolFromCurrency(
        this.orderDetail.currency_type
      );
      this.loading = false;
    }
  }

  ngOnDestroy() {
  }

  getReservations() {
    if (_.get(this.orderDetail, 'reservation_order.reservation_count') > 1) {
      this.orderService
        .getReservations({
          code: _.get(this.orderDetail, 'reservation_order.code'),
        })
        .subscribe((res) => {
          if (res.error_code === 0) {
            this.reservationList = _.filter(
              this.formatReservation(_.get(res, 'data.list')),
              (item) => item.code !== this.orderDetail.code
            );
          }
        });
    }
  }

  formatReservation(data) {
    _.forEach(data, (item) => {
      let picture;
      const pictures = _.get(item, 'house.cover');
      if (pictures) {
        picture = JSON.parse(pictures);
      }
      const url = _.get(picture, 'small_url');
      const houseTitle = _.get(item, 'house_title');
      const titleAlias = _.get(item, 'title_alias');
      _.assign(item, {
        picture: url,
        title:
          titleAlias && titleAlias !== ''
            ? titleAlias
            : houseTitle && houseTitle !== ''
            ? houseTitle
            : this.translateService.syncGet('word.none'),
      });
    });
    return data;
  }

  initStatus() {
    this.checkInOPen = false;
    this.checkOutOPen = false;
    this.showOrderAmount = true;
    this.showOrderInfo = true;
    this.showOrderRemarks = true;
    this.showHousesInfo = false;
  }

  getOptions() {
    this.orderService.gethouseStatusSettingOptions().subscribe((options) => {
      this.channelOptions = _.get(options, 'reservation_channel');
      this.leavedChannelOptions = _.filter(
        this.channelOptions,
        (item) => ![5, 20, 21].includes(item.code) && !item.delete_time
      );

      this.listOfTag = options?.tag_list?.filter(t => !t.delete_time && t.id !== 1).map(t => ({
        label: t.tag_name,
        value: t.id,
        color: t.color
      }))
    });
  }

  getCurrencyList() {
    this.orderService.getCurrency().subscribe((res) => {
      if (res.error_code === 0) {
        this.currencyList = _.get(res, 'data.currency_list');
      }
    });
  }

  getExchangeRate() {
    const params = {
      from: 'CNY',
      to: _.get(this.orderDetail, 'currency_type'),
    };
    this.houseStatusService.getExchangeRate(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.maxAmount = Math.floor(this.maxAmount * _.get(res, 'data.quote'));
      }
    });
  }

  refreshForTag() {
    this.orderService.refreshOrderDetailOrNot.subscribe((message) => {
      if (message === 'refresh') {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        this.orderService.refreshOrderDetailOrNot.emit('notRefresh');
      }
    });
  }

  format(data) {
    const statusMap = _.groupBy(data.housing_status, 'available');
    const amount = _.get(data, 'amount_items.settlement_amount.amount');
    const status = _.get(data, 'amount_items.settlement_status.status');
    const paid_amount = amount < 0 ? Math.abs(amount) : amount;
    const orderStatus = _.get(data, 'out_status');
    const orderNumber = _.get(data, 'reservation_order.reservation_count');
    const onlineExtended =
      _.get(data, 'thirdparty_type') !== 5 &&
      _.get(data, 'amount_items.extension_house_fee.amount') !== 0;
    const statusBackground =
      orderStatus === 'wait_stay'
        ? '#22975d'
        : orderStatus === 'staying'
        ? '#db5172'
        : orderStatus === 'completed'
        ? '#3475bc'
        : 'none';
    const visibleTime = _.get(data, 'guide_info.visible_password_time');
    const needCredential = _.get(data, 'guide_info.need_credential');
    // const hourOrders = _.get(data, "hour_reservations");
    // const index = _.findIndex(hourOrders, [
    //   "reservation_code",
    //   this.orderDetail.code,
    // ]);
    const hourOrderStartTime = this.orderDetail.is_hour_reservation
      ? `${this.orderDetail.check_in} ${this.orderDetail.check_in_time}`
      : null;
    const hourOrderEndTime = this.orderDetail.is_hour_reservation
      ? `${this.orderDetail.check_out} $${this.orderDetail.check_out_time}`
      : null;
    const diffHour =
      moment(hourOrderEndTime).diff(moment(hourOrderStartTime), 'minutes') / 60;
    Object.assign(data, {
      status_map: statusMap,
      settled: status,
      paid_amount: paid_amount,
      statusBackground: statusBackground,
      onlineExtended: onlineExtended,
      singleOrMass: orderNumber === 1 ? 'single' : 'mass',
      hourOrderStartTime: this.orderDetail.is_hour_reservation
        ? hourOrderStartTime
        : null,
      hourOrderEndTime: this.orderDetail.is_hour_reservation
        ? hourOrderEndTime
        : null,
      diffHour: diffHour,
    });
    this.form.patchValue({
      currency: _.get(data, 'currency_type'),
    });
    this.showGuideInfo = true;
    if (!_.get(this.orderDetail, 'guide_info')) {
      this.showGuideInfo = false;
      return data;
    }
    if (_.get(this.orderDetail, 'guide_info.lock.lock_status') !== -1) {
      this.patchingValue = true;
      this.form.patchValue({
        visible_password_time: visibleTime,
      });
    }
    if (_.get(this.orderDetail, 'guide_info.need_credential') !== -1) {
      this.patchingValue = true;
      this.form.patchValue({
        need_credential: needCredential,
      });
    }
    this.automation =  _.get(this.orderDetail, 'automation')

    this.currentTags = data?.reservation_tag?.map(t => t.id);
    // this.depositDetail = _.get(this.orderDetail, 'guide_info.deposit');
    // this.deposit = _.get(this.depositDetail, 'receivable');

    // this.currentCreatorId = _.get(this.orderDetail, 'operator_id')
    return data;
  }

  jumpToHouse(houseId) {
    this.modalService.closeAll();
    this.router.navigate(['/app/properties/detail'], {
      queryParams: {
        id: houseId,
      },
    });
  }

  jumpToHouseType(houseTypeId) {
    this.modalService.closeAll();
    this.router.navigate(['/app/room_types/detail'], {
      queryParams: {
        id: houseTypeId,
      },
    });
  }

  initCheckTime() {
    const inTime = _.get(this.orderDetail, 'check_in_time');
    const outTime = _.get(this.orderDetail, 'check_out_time');
    if (inTime) {
      const inTimeTemp = _.split(inTime, ':');
      const inTimeValue = moment()
        .startOf('day')
        .add(inTimeTemp[0], 'hours')
        .add(inTimeTemp[1], 'minutes')
        .toDate();
      this.oldInTime = _.cloneDeep(inTimeValue);
      this.form.patchValue({
        inTime: inTimeValue,
      });
    } else {
      this.form.patchValue({
        inTime: null,
      });
    }
    if (outTime) {
      const outTimeTemp = _.split(outTime, ':');
      const outTimeValue = moment()
        .startOf('day')
        .add(outTimeTemp[0], 'hours')
        .add(outTimeTemp[1], 'minutes')
        .toDate();
      this.oldOutTime = _.cloneDeep(outTimeValue);
      this.form.patchValue({
        outTime: outTimeValue,
      });
    } else {
      this.form.patchValue({
        outTime: null,
      });
    }
  }

  onTagsChange(tags) {
    this.requestUpdateReservationTags(tags);
  }

  private requestUpdateReservationTags(tags) {
    const params = {
      reservation_code: this.orderDetail.code,
      operator_tag_ids: tags,
    };
    this.orderService.updateReservationTags(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        // this.calendarService.refresh();
      }
    });
  }

  manageTag() {
    this.modalService.closeAll();
    this.router.navigate(['/app/settings/options'], {
      queryParams: {
        index: 1,
      },
    });
  }

  checkReservation(code) {
    this.calendarService.selectReservation(code);
  }

  toOrderbox() {
    this.houseStatusService.getWidgetCount().subscribe((res) => {
      this.boxCount = _.get(res, 'data.box_count');
      const modal = this.modalService.create({
        nzTitle: this.translateService.syncGet('house.orderbox_task_count', {
          count: this.boxCount,
        }),
        nzWidth: 860,
        nzContent: HouseOrderboxComponent,
        nzFooter: null,
        nzComponentParams: {
          isHistory: _.get(this.orderDetail, 'is_history'),
        },
      });
      modal.afterClose.subscribe(() => {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
      });
    });
  }

  toHouseType() {
    this.modalService.closeAll();
    this.router.navigate(['/app/room_types/detail'], {
      queryParams: {
        subTab: 2,
        id: _.get(this.orderDetail, 'house_type_id'),
      },
    });
  }

  @WritePermissionGurd('reservation_list')
  closeHouse() {
    const temEnd = this.orderDetail.check_out;
    const end = moment(temEnd).subtract(1, 'days').format('YYYY-MM-DD');
    const params = {
      begin: this.orderDetail.check_in,
      end: end,
      id: this.orderDetail.house_id,
      available: 0,
      daily_price_list: '[]',
    };
    this.houseStatusService.editHouseDailyPrice(params).subscribe((res: any) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
      }
    });
  }

  findConflictDate() {
    // const params = {
    //   reservation_code: this.orderDetail.code,
    // };
    // this.orderService.forbiddenDateList(params).subscribe((res) => {
    //   if (res.error_code === 0) {
    //     this.conflictDate = res.data;
    //   }
    // });
  }


  // 编辑订单信息
  @WritePermissionGurd('reservation_list')
  editOrderInfo() {
    const judge = this.judgeEditOrNot();
    if (!judge) {
      return;
    }
    // this.findConflictDate();
    this.showOrderInfo = false;
    this.form.patchValue({
      channel: this.orderDetail.handmade_chanel,
      name: this.orderDetail.client ? this.orderDetail.client.name : '',
      mobile: this.orderDetail.client ? this.orderDetail.client.phone : '',
      date: this.orderDetail.is_hour_reservation
        ? this.orderDetail.check_in
        : [this.orderDetail.check_in, this.orderDetail.check_out],
      personCount: this.orderDetail.number_of_guests
        ? this.orderDetail.number_of_guests
        : 1,
    });
  }

  cancelEditOrderInfo() {
    this.showOrderInfo = true;
  }

  confirmEditOrderInfo() {
    this.showOrderInfo = true;
    const value = this.form.value;
    let check_in;
    let check_out;
    console.log(value.date);
    if (this.orderDetail.is_hour_reservation) {
      check_in = check_out = moment(value.date).format('YYYY-MM-DD');
    } else {
      check_in = moment(value.date[0]).format('YYYY-MM-DD');
      check_out = moment(value.date[1]).format('YYYY-MM-DD');
      if (check_in === check_out) {
        const errorText = this.translateService.syncGet(
          'errorText.order.in_out_date'
        );
        this.messageService.warning(errorText);
        return;
      }
    }
    const params = {
      reservation_code: this.orderDetail.code,
      check_in: check_in,
      check_out: check_out,
      name: value.name,
      mobile: value.mobile,
      number_of_guests: value.personCount,
      channel: value.channel,
    };
    this.orderService.modifyBasicInfo(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        this.calendarService.refresh();
        const successText = this.translateService.syncGet('success.save');
        this.messageService.success(successText);

        if (this.orderDetail.sync_lock === 0) {
          this.displayLockOrderTip();
        }
      }
    });
  }

  getDays(date: Array<any>) {
    return moment(date[1]).diff(moment(date[0]), 'days');
  }

  // 编辑订单金额
  @WritePermissionGurd('reservation_list')
  onModifyOrderFee() {
    this.checkingExtensionHouseFee = false;
    const judge = this.judgeEditOrNot();
    if (!judge) {
      return;
    }
    this.getExchangeRate();
    this.showOrderAmount = false;
    const fee = this.orderDetail.amount_items;
    this.form.patchValue({
      house_price: fee.house_fee.amount,
      commission: fee.commission ? fee.commission.amount : 0,
    });
  }

  cancelEditOrderAmount() {
    this.showOrderAmount = true;
  }

  onConfirmModifyOrderFee() {
    this.checkingExtensionHouseFee = true;
    const housePrice = this.form.get('house_price').value;
    if (_.isNil(housePrice) || housePrice === '') {
      return;
    }
    const onlineHouseFee = _.get(
      this.orderDetail,
      'amount_items.online_house_fee.amount'
    );
    if (this.orderDetail.onlineExtended && housePrice < onlineHouseFee) {
      return;
    }
    this.showOrderAmount = true;
    const value = this.form.value;
    const params = {
      reservation_code: this.orderDetail.code,
      house_fee: value.house_price,
      currency_type: value.currency,
    };
    if (value.commission !== '') {
      _.assign(params, {
        commission: value.commission,
      });
    } else {
      _.assign(params, {
        commission: 0,
      });
    }
    this.orderService.setModifyReservationAmount(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet('success.save');
        this.messageService.success(successText);

        if (this.orderDetail.sync_lock === 0) {
          this.displayLockOrderTip();
        }
      }
    });
  }

  private displayLockOrderTip () {
    this.modalService.confirm({
      // nzTitle: '是否锁定订单？',
      nzTitle: this.translateService.syncGet('reservation.detail.lock_order.modal.title'),
      // nzContent: '锁定此订单可避免系统自动同步时覆盖已修改的内容。重新读取此订单即可解除锁定。',
      nzContent: this.translateService.syncGet('reservation.detail.lock_order.modal.content'),
      nzOnOk: () => this.requestLockOrder()
    });
  }

  private requestLockOrder () {
    this.orderService.lockOrder({ reservation_code: this.orderDetail.code }).subscribe(res => {
      console.log('res: ', res);
      if (res.error_code === 0) {
        this.messageService.success(this.translateService.syncGet('success.save'));
      }
    })
  }

  foucusHousePrice() {
    this.checkingExtensionHouseFee = false;
  }

  // 编辑入住
  editInAndOut(type, el) {
    if (type === 'checkin') {
      this.checkInOPen = false;
    } else {
      this.checkOutOPen = false;
    }
    el.scrollIntoView();
    setTimeout(() => {
      const judge = this.judgeEditOrNot();
      if (judge) {
        if (type === 'checkin') {
          this.checkInOPen = true;
        } else {
          this.checkOutOPen = true;
        }
      }
    }, 50);
  }

  cancelEditIn() {
    this.form.patchValue({
      inTime: this.oldInTime ? this.oldInTime : null,
    });
    this.checkInOPen = false;
  }

  cancelEditOut() {
    this.form.patchValue({
      outTime: this.oldOutTime ? this.oldOutTime : null,
    });
    this.checkOutOPen = false;
  }

  @WritePermissionGurd('reservation_list')
  confirmEditInAndOut(type, v) {
    this.checkInOPen = false;
    this.checkOutOPen = false;
    if (type === 'checkin') {
      this.form.patchValue({ inTime: v });
    } else {
      this.form.patchValue({ outTime: v });
    }
    const value = this.form.value;
    if (!value.inTime && !value.outTime) {
      return;
    }
    // const params = {
    //   reservation_code: this.orderDetail.code,
    //   check_in_time: value.inTime ? moment(value.inTime).format(this.timeFormat) : null,
    //   check_out_time: value.outTime
    //     ? moment(value.outTime).format(this.timeFormat)
    //     : null
    // };
    const params = {
      reservation_code: this.orderDetail.code,
      check_in_time: value.inTime ? moment(value.inTime).format('HH:mm') : null,
      check_out_time: value.outTime
        ? moment(value.outTime).format('HH:mm')
        : null,
    };
    this.orderService.setCheckInAndOutTime(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet('success.save');
        this.messageService.success(successText);
      }
    });
  }

  // 编辑订单备注
  // @WritePermissionGurd('reservation_list')
  // editOrderRemarks() {
  //   const judge = this.judgeEditOrNot();
  //   if (!judge) {
  //     return;
  //   }
  //   this.showOrderRemarks = false;
  //   this.form.patchValue({
  //     reservation_note: this.orderDetail.note ? this.orderDetail.note : '',
  //   });
  // }
  //
  // cancelEditOrderRemarks() {
  //   this.showOrderRemarks = true;
  // }
  //
  // confirmEditOrderRemarks() {
  //   this.showOrderRemarks = true;
  //   const value = this.form.value;
  //   const params = {
  //     reservation_code: this.orderDetail.code,
  //     note: value.reservation_note,
  //   };
  //   this.orderService.addANote(params).subscribe((res) => {
  //     if (res.error_code === 0) {
  //       this.refresh = true;
  //       this.refreshModal.emit(this.refresh);
  //       const successText = this.translateService.syncGet('success.save');
  //       this.messageService.success(successText);
  //     }
  //   });
  // }

  RereadOrder() {
    this.orderService
      .refreshReservationOrder({
        reservation_order_code: _.get(
          this.orderDetail,
          'reservation_order.code'
        ),
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          // 正在重新读取订单数据
          const warningText = this.translateService.syncGet(
            'warning.reading_order_detail'
          );
          this.messageService.warning(warningText);
        }
      });
  }

  judgeEditOrNot() {
    if (
      !this.showOrderAmount ||
      !this.showOrderRemarks ||
      !this.showOrderInfo
    ) {
      const warningText = this.translateService.syncGet(
        'errorText.order.cannot_edit_module'
      );
      this.messageService.warning(warningText);
      return false;
    }
    return true;
  }

  @WritePermissionGurd('reservation_list')
  orderChangeHouse() {
    const title = this.translateService.syncGet('order.change_to_house');
    const changeModal = this.modalService.create({
      nzTitle: title,
      nzContent: OrderMoveHouseComponent,
      nzFooter: null,
      nzWidth: '936px',
      nzComponentParams: {
        codes: this.orderDetail.code,
      },
    });
    changeModal.afterClose.subscribe((res) => {
      if (res) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        this.calendarService.refresh();
      }
    });
  }

  @WritePermissionGurd('reservation_list')
  moveToOrderBox() {
    const params = {
      reservation_code: this.orderDetail.code,
    };
    this.orderService.putReservationBox(params).subscribe((res) => {
      if (res.error_code === 0) {
        const successText = this.translateService.syncGet(
          'success.order.order_already_in_orderbox'
        );
        this.messageService.success(successText);
        this.calendarService.refresh();
        // this.calendarService.removeReservation(this.orderDetail.code);
      }
    });
  }

  @WritePermissionGurd('reservation_list')
  toDialogueList() {
    this.modalService.closeAll();
    this.router.navigate(['/app/messages'], {
      queryParams: {
        thread_id: this.orderDetail.thread_id,
      },
    });
  }

  getHandMadeChannel(method) {
    const item = _.find(this.channelOptions, { code: method });
    return item && item.channel_name;
  }

  @WritePermissionGurd('reservation_list')
  revocation(params: number, type) {
    // params=0代表撤销操作，params=1代表办理操作
    const out_status = this.orderDetail.out_status;
    if (out_status === 'staying') {
      if (params === 0) {
        this.modalService.warning({
          // 确定撤销入住吗？订单将变为待入住状态。
          nzContent: this.translateService.syncGet(
            'warning.order.confirm_cancel_check_in'
          ),
          nzOnOk: () => this.revocationQuery('staying_wait'),
          nzCancelText: this.translateService.syncGet('word.cancel'),
        });
      } else {
        this.modalService.warning({
          nzTitle: this.translateService.syncGet(
            'warning.order.confirm_check_out'
          ),
          nzContent: this.translateService.syncGet(
            'warning.order.confirm_tenant_out'
          ),
          nzOnOk: () => {
            this.revocationQuery('staying_checkout', type);
          },
          nzCancelText: this.translateService.syncGet('word.cancel'),
          nzOkText: this.translateService.syncGet('word.confirm'),
        });
      }
    }
    if (out_status === 'completed') {
      this.modalService.warning({
        // 确定撤销退房吗？订单将变为入住中状态。
        nzContent: this.translateService.syncGet(
          'warning.order.confirm_cancel_check_out'
        ),
        nzOnOk: () => this.revocationQuery('staying_checkin'),
        nzCancelText: this.translateService.syncGet('word.cancel'),
      });
    }
    if (out_status === 'wait_stay') {
      this.modalService.warning({
        nzTitle: this.translateService.syncGet(
          'warning.order.confirm_check_in'
        ),
        nzContent: this.translateService.syncGet(
          'warning.order.confirm_tenant_in'
        ),
        nzOnOk: () => {
          this.revocationQuery('staying_checkin', type);
        },
        nzCancelText: this.translateService.syncGet('word.cancel'),
        nzOkText: this.translateService.syncGet('word.confirm'),
      });
    }
  }

  revocationQuery(toStatus: string, type?: string) {
    let params;
    if (type === 'single' || !type) {
      params = {
        reservation_code: this.orderDetail.code,
        to_status: toStatus,
      };
    } else {
      params = {
        reservation_order_code: _.get(
          this.orderDetail,
          'reservation_order.code'
        ),
        to_status: toStatus,
      };
    }
    this.orderService.handleStayingStatus(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
      }
    });
  }

  @WritePermissionGurd('reservation_list')
  continueStay(type) {
    const extend = this.translateService.syncGet('order.continue_stay');
    const batchExtended = this.translateService.syncGet(
      'order.multi_continue_stay'
    );
    const title = type === 'single' ? extend : batchExtended;
    const modalInstance = this.modalService.create({
      nzTitle: title,
      nzContent: ContinueStayComponent,
      nzFooter: null,
      nzWidth: 390,
      nzComponentParams: {
        reservation_code:
          type === 'single'
            ? this.orderDetail.code
            : this.orderDetail.reservation_order.code,
        type: type,
      },
    });
    modalInstance.afterClose.subscribe((res) => {
      if (res && res.refresh === true) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
      }
    });
  }

  @WritePermissionGurd('reservation_list')
  cancelOrder() {
    if (this.orderDetail.is_hour_reservation) {
      this.questCancel();
    } else {
      this.modalService.warning({
        nzTitle: this.translateService.syncGet(
          'warning.order.confirm_cancel_order'
        ),
        nzContent: this.translateService.syncGet(
          'warning.order.cancel_order_info'
        ),
        nzOnOk: () => this.questCancel(),
        nzCancelText: this.translateService.syncGet('word.cancel'),
      });
    }
  }

  questCancel() {
    const params = {
      reservation_code: this.orderDetail.code,
    };
    this.orderService.deleteHandmadeOrder(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.calendarService.removeReservation(this.orderDetail.code);
        const successText = this.translateService.syncGet(
          'success.order.cancel_order'
        );
        this.messageService.success(successText);
        if (this.pageType === 'sidebar') {
          this.calendarService.cancelSelectReservation();
          this.calendarService.refresh();
        } else {
          this.refresh = true;
          this.refreshModal.emit(this.refresh);
        }
      }
    });
  }

  @WritePermissionGurd('reservation_list')
  acceptOrder() {
    this.acceptLoading = true;
    const params = {
      reservation_code: this.orderDetail.code,
    };
    this.orderService.approveReservation(params).subscribe((res) => {
      this.acceptLoading = false;
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet(
          'success.order.accept_order'
        );
        this.messageService.success(successText);

        this.globalModalService.displayTujiaAutoReceiptModal(
          this.orderDetail.code
        );
      } else {
        const warningText = this.translateService.syncGet(
          'warning.order.accept_order_failed'
        );
        this.messageService.warning(warningText);
      }
    });
  }

  @WritePermissionGurd('reservation_list')
  refuseOrder() {
    this.refuseLoading = true;
    const params = {
      reservation_code: this.orderDetail.code,
    };
    this.orderService.declineReservation(params).subscribe((res) => {
      this.refuseLoading = false;
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet(
          'success.order.refuse_order'
        );
        this.messageService.success(successText);
      } else {
        const warningText = this.translateService.syncGet(
          'warning.order.refuse_order_failed'
        );
        this.messageService.warning(warningText);
      }
    });
  }

  close() {
    this.calendarService.cancelSelectReservation();
  }

  @WritePermissionGurd('reservation_list')
  addFinance() {
    const title = this.translateService.syncGet('word.add_note');
    const modalInstance = this.modalService.create({
      nzTitle: title,
      nzContent: NoteV2Component,
      nzWidth: 900,
      nzFooter: null,
      nzComponentParams: {
        createOrEdit: 'create',
        orderOrWhole: 'order',
        orderDetailCode: this.orderDetail.code,
        currency: this.orderDetail.currency_type,
      },
    });
    modalInstance.afterClose.subscribe((res) => {
      if (res && res.refresh === true) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
      }
    });
  }

  currencyChange() {
    this.orderDetail.currency_type = this.form.value.currency;
  }

  toLog(type: 'reservation' | 'reservation_order', code: string) {
    this.modalService.closeAll();
    this.router.navigate(['/app/system'], {
      queryParams: {
        tab: 1,
        logType: type,
        code: code,
      },
    });
  }

  // 手动填写密码
  manuallyFillIn() {
    this.fillInPasswordManually = true;
    setTimeout(() => {
      this.el.nativeElement.querySelector('.input-password').focus();
    }, 300);
  }

  cancelEditLockPassword() {
    this.fillInPasswordManually = false;
    this.form.patchValue({
      password: null,
    });
  }

  saveLockPassword() {
    this.fillInPasswordManually = false;
    const value = this.form.value;
    if (!value.password || value.password === '') {
      return;
    }
    const params = {
      reservation_code: this.orderDetail.code,
      type: 2, // 手动填写
      password: value.password,
    };
    this.orderService.setGuide(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet('success.save');
        this.messageService.success(successText);
      }
    });
  }

  jumpToRoomCheckinDetail(houseId) {
    this.modalService.closeAll();
    this.router.navigate(['/app/properties/detail'], {
      queryParams: {
        id: houseId,
        activeIndex: 0,
        subTab: 2,
      },
    });
  }

  // 自动生成密码
  createPassword() {
    const params = {
      reservation_code: this.orderDetail.code,
      type: 1, // 随机生成
    };
    this.orderService.setGuide(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet(
          'order.password_creating'
        );
        this.messageService.success(successText);
      }
    });
  }

  // 删除门锁密码
  deletePassword() {
    const params = {
      reservation_code: this.orderDetail.code,
      type: 3, // 删除密码
    };
    this.orderService.setGuide(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet(
          'success.password_deleted'
        );
        this.messageService.success(successText);
      }
    });
  }

  visiblePasswordTimeChange() {
    if (this.patchingValue) {
      this.patchingValue = false;
      return;
    }
    const value = this.form.value;
    const oldTime = this.orderDetail.guide_info.visible_password_time;
    if (
      oldTime === value.visible_password_time ||
      !value.visible_password_time
    ) {
      return;
    }
    const params = {
      reservation_code: this.orderDetail.code,
      type: 4, // 设置密码可见时间
      visible_password_time: value.visible_password_time,
    };
    this.orderService.setGuide(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet('success.save');
        this.messageService.success(successText);
      }
    });
  }

  identityRegistrationChange() {
    if (this.patchingValue) {
      this.patchingValue = false;
      return;
    }
    const value = this.form.value;
    const oldCredential = this.orderDetail.guide_info.need_credential;
    if (oldCredential === value.need_credential) {
      return;
    }
    const params = {
      reservation_code: this.orderDetail.code,
      type: 5, // 设置是否需要登记
      need_credential: value.need_credential,
    };
    this.orderService.setGuide(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        const successText = this.translateService.syncGet('success.save');
        this.messageService.success(successText);
      }
    });
  }

  onClickConflictLink() {
    const conflictIds = this.orderDetail.conflict_label.conflict_ids;
    window.open('/app/reservations?conflict_ids=' + conflictIds.join(','))
  }

  onAutomationChange () {
    console.log('automation change', this.automation);
    this.requestSetAutomation();
  }

  private requestSetAutomation () {
    const params = {
      reservation_code: this.orderDetail.code,
      status: this.automation
    };
    this.orderService.setAutomation(params).subscribe(res => {
      console.log('request: ', res);
      if (res.error_code === 0) {
        this.messageService.success(this.translateService.syncGet('success.modify'));
      }
    })
  }

  handleImageChange(result) {
    console.log(result);
    const file = result.file;
    if (file.status === 'done') {
      const urls = _.get(file, 'response.data.file');
      this.orderService
        .addGuideImage({
          reservation_code: this.orderDetail.code,
          image: JSON.stringify(urls),
        })
        .subscribe((res) => {
          if (res.error_code === 0) {
            this.refresh = true;
            this.refreshModal.emit(this.refresh);
          }
        });
    }
  }

  checkCredential(auditStatus) {
    this.modalService.create({
      nzTitle: this.translateService.syncGet('word.credentials'),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        type: 'credentials',
        orderCode: this.orderDetail.reservation_order.code,
        code: this.orderDetail.code,
        auditStatus
      },
      nzOnOk: () => {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
      },
    });
  }

  expandHourCalendar() {
    this.storeService.set('collapse_hour_calendar_in_order_detail', false, 2);
    this.hourCalendarCollapsed = false;
  }

  collapseHourCalendar() {
    this.storeService.set('collapse_hour_calendar_in_order_detail', true, 2);
    this.hourCalendarCollapsed = true;
  }

  toRateDetail() {
    console.log('this.orderDetail: ', this.orderDetail);
    this.switchPageService.navigate(PageName.RateDetail, {
      code: this.orderDetail.reservation_order.code,
    });
  }

  JumptoHourDetail(code) {
    if (this.pageType === 'sidebar') {
      this.calendarService.selectReservation(code);
      return;
      // 从订单到小时单的侧边栏，需要在链表中加入两个节点，因为当前页面点击小时单就变成了小时单
    } else {
      if (!this.orderDetail.is_hour_reservation) {
        this.modalService.create({
          nzTitle: this.translateService.syncGet('word.order_detail'),
          nzContent: HouseOrderDetailComponent,
          nzFooter: null,
          nzWidth: 900,
          nzComponentParams: {
            code: code,
            pageType: 'modal',
          },
        });
      } else {
        this.changeOrder.emit({ code: code });
      }
    }
  }

  createNewHourOrder(date) {
    if (this.pageType !== 'sidebar') {
      return;
    }
    this.calendarService.cancelSelectReservation();
    this.switchPageService.destroyCurrentLianBiao();
    const params = {
      house: {
        id: this.orderDetail.house_id,
        house_title: this.orderDetail.house_title,
      },
      date: date,
    };
    this.calendarService.displayHourReservationSidebar(params);
  }

  fetchSubaccountList () {
    const params = {
      page: '1',
      page_size: '1000',
      format: 'reservation_creator'
    };
    this.orderService.fetchSubaccountList(params).subscribe(rst => {
      this.listOfSubaccount = _.get(rst, 'data.list');
    });
  }

  requestSetCreator () {
    const creator = _.find(this.listOfSubaccount, a => a.operator_id === this.currentCreatorId);
    if (!creator) {
      return;
    }
    const params = {
      reservation_code: this.orderDetail.code,
      ...creator
    };
    this.orderService.requestSetCreator(params).subscribe(rst => {
      if (rst.error_code === 0) {
        // this.messageService.success('设置成功');
        this.messageService.success(
          this.translateService.syncGet('reservation.detail.creator.toast.set_success')
        );
      }
    })
  }

}
